<template>
  <div class="vx-row">
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div class="w-full">
      <div slot="no-body" class="tabs-container pt-6" id="view-customer-tab">
        <vx-card>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="provisioningActionsList"
            :description="false"
            search
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("system.label.ProvisioningActions") }}
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("system.label.ProvisionType") }}</vs-th>
              <vs-th>{{ $t("system.label.Action") }}</vs-th>
              <vs-th>{{ $t("system.label.ProvisioningSystem") }}</vs-th>
              <vs-th>{{ $t("system.label.IsEnable") }}</vs-th>
              <vs-th>{{ $t("system.label.Action") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="provisioningActionsList"
                v-for="(provisioningActionsList, index) in data"
              >
                <vs-td :data="provisioningActionsList.provisionType">{{
                  provisioningActionsList.provisionType
                }}</vs-td>
                <vs-td :data="provisioningActionsList.action">{{
                  provisioningActionsList.action
                }}</vs-td>
                <vs-td :data="provisioningActionsList.provisioningSystem">{{
                  provisioningActionsList.provisioningSystem
                }}</vs-td>
                <vs-td :data="provisioningActionsList.isEnable">{{
                  provisioningActionsList.isEnable === "Y" ? "Y" : "N"
                }}</vs-td>
                <vs-td>
                  <vs-switch
                    :checked="isEnableSwitch(provisioningActionsList.isEnable)"
                    @change="toggleSwitch(provisioningActionsList)"
                  />
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </vx-card>
      </div>
    </div>
  </div>
</template>
<script>
import { AtomSpinner } from "epic-spinners";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
      deletePopup: false,
      deleteProvisioningPopup: false,
      delId: 0,
    };
  },
  components: {
    AtomSpinner,
  },
  computed: {
    ...mapGetters({
      provisioningActionsList: "provisioningConfig/getprovisioningActionList",
    }),
  },
  methods: {
    async getActionsData() {
      this.loading = true;
      try {
        await this.$store.dispatch(
          "provisioningConfig/setprovisioningActionsData"
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
      this.loading = false;
    },

    isEnableSwitch(isEnable) {
      return isEnable === "Y";
    },

    async toggleSwitch(provisioningActionsList) {
      try {
        // Toggle the isEnable value
        const updatedIsEnable =
          provisioningActionsList.isEnable === "Y" ? "N" : "Y";
        await this.updateProvisioningActions(provisioningActionsList.id, {
          isEnable: updatedIsEnable,
          status: updatedIsEnable === "Y" ? "true" : "false",
        });
        provisioningActionsList.isEnable = updatedIsEnable;
      } catch (error) {
        console.error("Error updating provisioningActions:", error);
      }
    },

    async updateProvisioningActions(id, payload) {
      try {
        await this.$store.dispatch(
          "provisioningConfig/updateProvisioningActionsAction",
          { id: id, data: payload }
        );
      } catch (error) {
        console.error("Error updating provisioningActions:", error);
        throw error;
      }
    },
  },
  mounted() {
    this.getActionsData();
  },
};
</script>
<style scoped>
::v-deep .vs-tabs--ul {
  width: 90%;
}
</style>
